// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__z0JuU","productName":"Table_productName__2ABeW"};